import { z } from "zod";
import { optionalTrimmedString, trimmedString } from "./primitives";

export const threadMessageSchema = z.object({
  author: trimmedString,
  body: trimmedString,
});

export const threadCustomerSchema = z.object({
  name: optionalTrimmedString,
  email: optionalTrimmedString,
});

export const createThreadSchema = z.object({
  subject: optionalTrimmedString,
  messages: z.array(threadMessageSchema).min(1, "Messages must include at least one entry."),
  customer: threadCustomerSchema.optional(),
});

export type CreateThreadPayload = z.infer<typeof createThreadSchema>;
export type ThreadMessagePayload = z.infer<typeof threadMessageSchema>;

export const threadSnapshotResponseSchema = z.object({
  snapshot: trimmedString,
});

export type ThreadSnapshotResponse = z.infer<typeof threadSnapshotResponseSchema>;

export const aiContextSnapshotSlaStateSchema = z.object({
  status: z.enum(["none", "on_track", "at_risk", "breached"]),
  targetAt: trimmedString.optional(),
  ruleName: trimmedString.optional(),
  minutesRemaining: z.number().int().nonnegative().optional(),
  thresholdHours: z.number().nonnegative().optional(),
});

export const aiContextSnapshotSchema = z.object({
  generatedAt: trimmedString,
  insights: z.array(trimmedString).min(1),
  priority: z.enum(["low", "medium", "high", "critical"]),
  impact: trimmedString,
  confidence: z.number(),
  intent: optionalTrimmedString,
  provider: trimmedString,
  modelVersion: trimmedString,
  promptVersion: trimmedString,
  requestId: trimmedString,
  guardrailWarnings: z.array(trimmedString),
  slaState: aiContextSnapshotSlaStateSchema,
  customer: optionalTrimmedString,
  triageRule: optionalTrimmedString,
  fallbackUsed: z.boolean(),
  cacheHit: z.boolean(),
});

export type AiContextSnapshot = z.infer<typeof aiContextSnapshotSchema>;

export const threadContextSnapshotResponseSchema = z.object({
  snapshot: aiContextSnapshotSchema.nullable(),
});

export type ThreadContextSnapshotResponse = z.infer<
  typeof threadContextSnapshotResponseSchema
>;
